/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Page from 'material/structure/page/page';
import Section from 'material/section/section';
import Content from 'material/structure/content/content';
import LineChart from 'material/chart/linechart/linechart_container';
import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import Link from 'material/ctas/link/link_container';
import Grid from 'material/grid/grid';
import GridSet from 'material/grid/gridset/gridset';
import GridItem from 'material/grid/griditem/griditem';
import Icon from 'material/graphic/icon/icon';
import DropFilter from 'material/dropdowns/dropfilter/dropfilter';
import DateRangePickerDropDown from 'material/dropdowns/daterangepickerdropdown/daterangepickerdropdown';
import Table from 'material/table/table';
import Control from 'material/controls/control/control';
//utils
import { isAfterFourPM } from 'utils/isafterfourpm';
import { transpileTableBody, transpileByDateTableColumnHead, detailChartData } from 'utils/data_visualization_transpilers';
import { generateMetricsAPIString } from 'utils/fetchContentHelpers';
import { getAllDetailData } from 'utils/api/detail';
import { handleSiteInDropDown, handleCountriesInDropDown, handleDevicesInDropDown, tooltipHelper } from 'pages/dashboard/analytics/detail/detailhelpers';

// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/analytics/detail/metrics/cpm/cpm_styles';




/* ========== ~~~~~~~~~~ PAGE : DATA DETAIL : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary

class CPM extends Component {
    constructor(props){
        super(props);
        this.topRank = 15;
        this.dataType = 'CPM';
        this.viewType = this.props.selectedRevenueType;
        this.state={
            controlSelected: `SITE`
        }
    }

    componentWillMount(){
        this.fetchCPMData(this.state.controlSelected, {topRank: this.topRank});
    }

    componentWillUnmount(){
        this.props.clearDetailState();
    }
    //fetch data call
    fetchCPMData = (controlSelected, extendAPIProps) => this.props.getDetailRevenueMetrics(generateMetricsAPIString({accountUUID: this.props.accountUUID, dataType: this.dataType, revenueType: this.viewType, dateRange: this.props.dateRange, viewType: controlSelected, ...extendAPIProps}), 'CPM');

    handleChartValue = data => {
        let value = data.total && data.total.aggregate ? data.total.aggregate : null;
        if (!value) return;
        return parseFloat(value).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
    };
    //-=-=-=Control actions-=-=-=//
    handleSitesControlClick = () => {
        this.props.updateDetailDropDown([], 'SITE');
        this.setState({controlSelected: 'SITE'});
        this.fetchCPMData('SITE', {topRank: this.topRank});
    };
    handleDevicesControlClick = () => {
        this.setState({controlSelected: 'DEVICE'});
        this.fetchCPMData('DEVICE', {topRank: this.topRank});
    };
    handleGeoControlClick = () => {
        this.setState({controlSelected: 'GEO'});
        this.props.fetchCountries(this.props.accountUUID, `?startDate=${this.props.dateRange.from}&endDate=${this.props.dateRange.to}`);
        this.fetchCPMData('GEO', {topRank: this.topRank});
    };
    handleAdUnitsControlClick = () => {
        this.setState({controlSelected: 'AD_UNIT'});
        this.props.fetchRONSites(this.props.accountUUID, `?startDate=${this.props.dateRange.from}&endDate=${this.props.dateRange.to}&filterRonSites=true`);
        this.fetchCPMData('AD_UNIT', {topRank: this.topRank});
    };
   handleVideoAdsControlClick = () => {
        this.setState({controlSelected: 'AD_TYPE'});
        this.fetchCPMData('AD_TYPE', {topRank: this.topRank});
    };
    //-=-=-=-=--Filter Data Dropdown actions -=-=-=-=//
    handleSitesFilterApply = sites => this.fetchCPMData(this.state.controlSelected, { sites });
    handleDevicesFilterApply = devices => this.fetchCPMData(this.state.controlSelected, { devices });
    handleGeoFilterApply = countries => this.fetchCPMData(this.state.controlSelected, { countries });
    handleDateRangeApply = () => this.fetchCPMData(this.state.controlSelected, {topRank: this.topRank});
    //this function will take selected items and populate reducer based on controlSelected state
    handleDropDownSelect = (items) => this.props.updateDetailDropDown(items, this.state.controlSelected);

    renderTitle = () => this.viewType ? this.viewType === 'VIDEO' ? 'Video Ad CPM' : 'Display Ad CPM' : 'CPM';


    //this method returns an object that contains props needed to export current metrics that are displayed on screen in to an excel file
    //fileName and excludedColumns
    exportCurrentProps = () => ({
        fileName: this.dataType,
        excludedColumns: ['embed_uuid', '']
    });
    //this method returns an object that contains props needed to export current metrics that are displayed on screen in to an excel file
    //fileName, excludedColumns, and a paramstring that is used to make a BE call to fetch data for all sites, adunits, countries, etc. depending on current viewType
    exportAllProps = () => ({
        requestAllDetailData: getAllDetailData('cpm'),
        fileName: this.dataType,
        excludedColumns: ['embed_uuid', ''],
        paramString: generateMetricsAPIString({
            accountUUID: this.props.accountUUID,
            dateRange: this.props.dateRange,
            viewType: this.state.controlSelected,
            dataType: this.dataType,
            revenueType: this.viewType
        })
    });
    //if client preSelected a viewType from home page this control will not be rendered
    renderVideoAdControl = () => !this.viewType ? <Control selected={this.state.controlSelected} text={`Ad Type`} value={`AD_TYPE`} handleSelect={this.handleVideoAdsControlClick} /> : null;

    render() {

        return(
            <Page name={`cpm`} klass={`${this.props.classes.cpm} filter-${this.state.controlSelected}`}>
                <Content>

                    <Section name={`detailheader`}>
                        <Grid>
                            <GridSet direction={`horizontal`} name={`detailtitle`}>
                                <GridItem>
                                    <Copy>
                                        <Link type={`internal`} behavior={`back`} text={`Back to all metrics`} color={`primary`} action={`dashboard/home`} icon={<Icon name={`hand-point-left`} />} />
                                        <Title><h2>{this.renderTitle()}</h2></Title>
                                    </Copy>
                                </GridItem>
                                <GridItem>
                                    <DateRangePickerDropDown handleApply={this.handleDateRangeApply} range={this.props.dateRange} disabledDays={[ { after: new Date(new Date() - (isAfterFourPM() ? (1000 * 60 * 60 * 24) : (1000 * 60 * 60 * 24 * 2))) } ]} updateRange={this.props.updateDateRange} />
                                </GridItem>
                            </GridSet>
                            <GridSet direction={`horizontal`} name={`detailfilters`}>
                                <GridItem name={`filters`}>
                                    <GridItem><DropFilter variant={'all-sites'} name={this.props.selectedSites.length === 1 ? 'site' : 'sites'} title={'All Sites'} icon={`link`} button={'true'} onSelect={this.handleDropDownSelect} buttonAction={this.handleSitesFilterApply} items={handleSiteInDropDown(this.state.controlSelected === 'AD_UNIT' ? this.props.ronSites : this.props.sites)} selectedItems={this.props.selectedSites} disabled={this.state.controlSelected === 'AD_UNIT' ? !this.props.ronSitesReceived : !this.props.sitesReceived}/></GridItem>
                                    <GridItem><DropFilter name={this.props.selectedDevices.length === 1 ? 'device' : 'devices'} title={'All Devices'} icon={`mobile-alt`} button={'true'} onSelect={this.handleDropDownSelect} buttonAction={this.handleDevicesFilterApply} items={handleDevicesInDropDown(this.props.devices)} selectedItems={this.props.selectedDevices}/></GridItem>
                                    <GridItem><DropFilter name={this.props.selectedCountries.length === 1 ? 'country' : 'countries'} title={'All Countries'} icon={`globe`} button={'true'} onSelect={this.handleDropDownSelect} buttonAction={this.handleGeoFilterApply} items={handleCountriesInDropDown(this.props.countries)}  selectedItems={this.props.selectedCountries} disabled={!this.props.countriesReceived} /></GridItem>
                                </GridItem>
                                <GridItem direction={`horizontal`} name={`controls`}>
                                    <Control selected={this.state.controlSelected} text={`Sites`} value={`SITE`} handleSelect={this.handleSitesControlClick} />
                                    <Control selected={this.state.controlSelected} text={`Devices`} value={`DEVICE`} handleSelect={this.handleDevicesControlClick} />
                                    <Control selected={this.state.controlSelected} text={`Geo`} value={`GEO`} handleSelect={this.handleGeoControlClick} />
                                    <Control selected={this.state.controlSelected} text={`Ad Units`} value={`AD_UNIT`} handleSelect={this.handleAdUnitsControlClick} />
                                    {this.renderVideoAdControl()}
                                </GridItem>
                            </GridSet>
                        </Grid>
                    </Section>

                    <Section name={`detailchart`}>
                        <LineChart
                            variant={`detail`}
                            label={this.renderTitle()}
                            value={this.handleChartValue(this.props.cpmDetail)}
                            tooltip={`This is the average ${tooltipHelper(this.props.selectedRevenueType)} CPM generated for you by Insticator`}
                            data={detailChartData(this.props.cpmDetail)}
                            metricType={'dollar'}
                            loading={this.props.fetchingRevenue}
                        />
                    </Section>

                    <Section name={`detailtable`}>
                        <Table
                            name={`cpm`}
                            type={`fixed-column`}
                            fixedColWidth={300}
                            size={`full`}
                            columnHeads={transpileByDateTableColumnHead(this.props.cpmDetail)}
                            data={transpileTableBody(this.props.cpmDetail, 'dollar')}
                            showTitle={true}
                            exportData={this.exportCurrentProps()}
                            exportAll={this.exportAllProps()}
                            paginationLocation={`top`}
                            rowsPerPage={7}
                            loading={this.props.fetchingRevenue}
                            moreDetails={false}
                        />
                    </Section>

                </Content>
            </Page>
        );
    }
}


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(CPM);